import { IWindow } from '../../../../../../services/analytics/adapters/mparticle'
import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { IProfile } from '../../../../../../services/common/profile'
import { UserEvents } from '../../user-events'

declare let window: IWindow
const mParticleEvents: any = new UserEvents()

export const SetAttributes = (profile?: IProfile, pid?: string) => {

    if (profile && profile.uuid) {
        mParticleEvents.setUserAttribute(key.CUSTOMER_ID, String(profile.uuid))
    }
    if(pid) {
        const today = new Date().toISOString().slice(0, 10) // tslint:disable-line: no-magic-numbers
        mParticleEvents.setUserAttribute(key.FC_INFO, `${pid}::${today}`)
    }

}
